import axios from "axios";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Loader from "./Loader";
import { clog } from "../lib/utils";

function GoogleSearchConsoleCallback() {
  const navigate = useNavigate();
  const [loading, setloading] = useState(false);
  const getGoogleSearchConsoleAccessToken = async (code) => {
    // clog(id);
    setloading(true);
    try {
      const response = await axios({
        url: `${process.env.REACT_APP_BASE_SIGNIN_URL}/googleapi/callback`,
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          jwt_token: localStorage.getItem("login_token"),
        },
        data: {
          website: localStorage.getItem("gsc_website"),
          code: code,
          user_id: JSON.parse(localStorage.getItem("login_data"))?.resp_user
            ?.id,
        },
      });
      if (!response.data.error) {
        // window.open(response.data.url, "_self");
        localStorage.setItem(
          "google_search_console_access",
          JSON.stringify({
            profile_url: localStorage.getItem("gsc_website"),
            access_token: response.data?.data?.access_token,
          })
        );
        let navigation = localStorage.getItem(
          "google_search_console_navigation"
        )
          ? localStorage.getItem("google_search_console_navigation")
          : "/integration-marketing";
        setTimeout(() => {
          navigate(navigation);
        }, 100);
      } else {
      }
    } catch (error) {
      clog(error);
      if (error.response && error?.response?.status == 401) {
        localStorage.removeItem("login_token");
        localStorage.removeItem("login_data");
        navigate("/");
      }
    } finally {
      setloading(false);
    }
  };
  useEffect(() => {
    const searchParams = new URLSearchParams(window.location.search);
    let code = searchParams.get("code");

    if (code) {
      getGoogleSearchConsoleAccessToken(code);
    }
  }, []);

  return (
    <div className="flex justify-center items-center h-screen">
      {loading && <Loader />}
    </div>
  );
}

export default GoogleSearchConsoleCallback;
